import { FC, useContext, useLayoutEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import styles from "./Sidebar.module.scss";
import { useResponsive } from "../../../helpers/customHooks/useResponsive";
import { ROLES, RoutingList } from "../../../constants";
import IMAGES from "../../../constants/images";
import { SidebarWidthMenu } from "../../../helpers/context/SidebarWidthMenu";
import { Button } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import WithPermission from "../WithPermission/WithPermission";

interface IMenu {
  isIrbOpen: boolean;
}

const Sidebar: FC = (): JSX.Element => {
  const menuInitial = {
    isIrbOpen: true,
  };
  const [isMobile] = useResponsive();
  const navRef = useRef<HTMLElement>(null);
  const { setSidebarWidth, toggleMenu, setToggleMenu } =
    useContext(SidebarWidthMenu);
  const [menuToggleBtn, setMenuToggleBtn] = useState<IMenu>(menuInitial);
  let location = useLocation();

  useLayoutEffect(() => {
    if (isMobile) {
      setSidebarWidth(0);
    } else {
      setSidebarWidth(navRef.current?.offsetWidth);
    }
  }, [isMobile, setSidebarWidth]);

  const closeMenu = () => {
    if (!isMobile) return;
    setToggleMenu(!toggleMenu);
  };

  const handleIrbMenu = () => {
    setMenuToggleBtn({ ...menuToggleBtn, isIrbOpen: !menuToggleBtn.isIrbOpen });
  };

  return (
    <>
      {(toggleMenu || !isMobile) && (
        <nav ref={navRef} className={styles.sideBar}>
          <div>
            <NavLink className={styles.navBrand} to={RoutingList.index.path}>
              <img src={IMAGES.LogoWhite} alt="logo" />
            </NavLink>
            <ul className={styles.sideBarMenu}>
              <WithPermission roles={[ROLES.ECS]}>
                <li>
                  <NavLink
                    className={styles.menuLink}
                    to={RoutingList.members.index.path}
                    onClick={closeMenu}
                  >
                    <span className={styles.menuIcon}>
                      <i className="icon-agent"></i>
                    </span>
                    <span>Member</span>
                  </NavLink>
                </li>
              </WithPermission>
              <WithPermission
                roles={[ROLES.ECS, ROLES.INVESTIGATOR, ROLES.MIRB]}
              >
                <li>
                  <Button
                    variant={"text"}
                    className={`${styles.menuLink} ${styles.menuToggle} ${
                      location.pathname.includes("/irb") && "active"
                    }`}
                    disableRipple={true}
                    onClick={handleIrbMenu}
                  >
                    <span className={styles.menuIcon}>
                      <i className="icon-tickets"></i>
                    </span>
                    <span>MIRB</span>
                    {menuToggleBtn.isIrbOpen ? (
                      <KeyboardArrowUp className={styles.toggleIcon} />
                    ) : (
                      <KeyboardArrowDown className={styles.toggleIcon} />
                    )}
                  </Button>
                  {menuToggleBtn.isIrbOpen && (
                    <ul className={`list-style-none ${styles.subMenu}`}>
                      <li>
                        <NavLink
                          className={styles.menuLink}
                          to={RoutingList.irb.index.path}
                          onClick={closeMenu}
                        >
                          <span>Submission</span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          className={styles.menuLink}
                          to={RoutingList.irbAdditional.index.path}
                          onClick={closeMenu}
                        >
                          <span>Additional Submission</span>
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>
              </WithPermission>
              <WithPermission
                roles={[ROLES.ECS, ROLES.INVESTIGATOR, ROLES.MIEC, ROLES.MSMC, ROLES.QA]}
              >
                <li>
                  <NavLink
                    className={styles.menuLink}
                    to={RoutingList.ethics_committee.index.path}
                    onClick={closeMenu}
                  >
                    <span className={styles.menuIcon}>
                      <i className="icon-agent"></i>
                    </span>
                    <span>EC Submission</span>
                  </NavLink>
                </li>
              </WithPermission>
              <WithPermission
                roles={[ROLES.ECS, ROLES.MIEC, ROLES.MSMC, ROLES.MIRB]}
              >
                <li>
                  <NavLink
                    className={styles.menuLink}
                    to={RoutingList.meeting.index.path}
                    onClick={closeMenu}
                  >
                    <span className={styles.menuIcon}>
                      <i className="icon-tickets"></i>
                    </span>
                    <span>Meeting</span>
                  </NavLink>
                </li>
              </WithPermission>
            </ul>
          </div>
        </nav>
      )}
    </>
  );
};
export default Sidebar;
